import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NavBar from './common/NavBar';
import { RoutePaths } from '../Constants/Common';
import { useAuth0 } from '@auth0/auth0-react';
import LandingPage from './sitePages/landingPage/LandingPage';
import RedirectAuthPage from './sitePages/RedirectAuthPage';
import VerifyEmailPage from './sitePages/VerifyEmailPage';
import HomePage from './sitePages/HomePage';
import ProductPage from './sitePages/product/ProductPage';
import ExistingRepairPage from './sitePages/repair/ExistingRepairPage';
import AlloyRepairRequestManager from './sitePages/alloyRepairRequest/AlloyRepairRequestManager';
import TyreRepairRequestManager from './sitePages/tyreRepairRequest/TyreRepairRequestManager';
import CosmeticRepairRequestManager from './sitePages/cosmeticRepairRequest/CosmeticRepairRequestManager';
import RepairRequestError from './sitePages/RepairRequestError';
import ConfirmationPage from './sitePages/ConfirmationPage';
import GeneralErrorPage from './sitePages/generalError/GeneralErrorPage';
import AuthenticationGuard from './common/auth/AuthenticationGuard';
import PersonalDetailsPage from './common/policyholderinfo/PersonalDetailsPage';
import AmendPersonalDetailsPage from './common/policyholderinfo/AmendPersonalDetailsPage';
import ViewDocumentPage from './sitePages/documents/ViewDocumentPage';
import AmendAddressPage from './common/policyholderinfo/AmendAddressPage';
import AmendEmailAddressPage from './common/policyholderinfo/AmendEmailAddressPage';
import ClaimDetailsPage from './common/policyholderinfo/ClaimDetailsPage';
import GapClaimSummary from './common/policyholderinfo/GapClaimSummary';
import ClaimNextStepsPage from './common/policyholderinfo/ClaimNextStepsPage';
import RepairRequestPreCheckPage from './sitePages/RepairRequestPreCheckPage';
import { t } from 'i18next';
import ClaimProvider from 'context/ClaimProvider';
import ClaimDocuments from './common/policyholderinfo/ClaimDocuments';

const LayoutContent = (): JSX.Element => {
    const { isAuthenticated, user } = useAuth0();
    const wrapperStyle = isAuthenticated ? 'site-content' : '';
    const verifiedUser = user?.email_verified === true;

    return (
        <div className='site-wrapper'>
            {verifiedUser && <NavBar />}
            <div className={wrapperStyle}>
                <Routes>
                    <Route
                        path={RoutePaths.LandingPage}
                        element={<LandingPage />}
                    />
                    <Route
                        path={RoutePaths.Redirect}
                        element={<RedirectAuthPage />}
                    />
                    <Route
                        path={RoutePaths.Verify}
                        element={<VerifyEmailPage />}
                    />
                    <Route
                        path={RoutePaths.Home}
                        element={
                            <AuthenticationGuard
                                component={HomePage}
                                path={RoutePaths.Home}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.Product}
                        element={
                            <AuthenticationGuard
                                component={ProductPage}
                                path={RoutePaths.Product}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.ViewRequests}
                        element={
                            <AuthenticationGuard
                                component={ExistingRepairPage}
                                path={RoutePaths.ViewRequests}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.Alloy}
                        element={
                            <AuthenticationGuard
                                component={AlloyRepairRequestManager}
                                path={RoutePaths.Alloy}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.Cosmetic}
                        element={
                            <AuthenticationGuard
                                component={CosmeticRepairRequestManager}
                                path={RoutePaths.Cosmetic}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.Tyre}
                        element={
                            <AuthenticationGuard
                                component={TyreRepairRequestManager}
                                path={RoutePaths.Tyre}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.ConfirmationError}
                        element={
                            <AuthenticationGuard
                                component={RepairRequestError}
                                path={RoutePaths.ConfirmationError}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.Confirmation}
                        element={
                            <AuthenticationGuard
                                component={ConfirmationPage}
                                path={RoutePaths.Confirmation}
                            />
                        }
                    />
                    <Route
                        path={RoutePaths.GeneralError}
                        element={<GeneralErrorPage />}
                    />
                    <Route
                        path={RoutePaths.PersonalDetails}
                        element={<PersonalDetailsPage />}
                    />
                    <Route
                        path={RoutePaths.AmendPersonalDetails}
                        element={<AmendPersonalDetailsPage />}
                    />
                    <Route
                        path={RoutePaths.AmendAddressDetails}
                        element={<AmendAddressPage />}
                    />
                    <Route
                        path={RoutePaths.AmendEmailAddress}
                        element={<AmendEmailAddressPage />}
                    />
                    <Route
                        path={RoutePaths.ViewDocuments}
                        element={<ViewDocumentPage />}
                    />
                    <Route
                        path={RoutePaths.ClaimDetails}
                        element={
                            <ClaimProvider>
                                <ClaimDetailsPage />
                            </ClaimProvider>
                        }
                    />
                    <Route
                        path={RoutePaths.ClaimSummary}
                        element={
                            <ClaimProvider>
                                <GapClaimSummary />
                            </ClaimProvider>
                        }
                    />
                    <Route
                        path={RoutePaths.ClaimNextSteps}
                        element={
                            <ClaimProvider>
                                <ClaimNextStepsPage />
                            </ClaimProvider>
                        }
                    />
                    <Route
                        path={RoutePaths.ClaimUploadDocuments}
                        element={
                            <ClaimProvider>
                                <ClaimDocuments />
                            </ClaimProvider>
                        }
                    />
                    <Route
                        path={RoutePaths.RepairRequestPreCheck}
                        element={
                            <AuthenticationGuard
                                component={RepairRequestPreCheckPage}
                                path={RoutePaths.RepairRequestPreCheck}
                            />
                        }
                    />
                </Routes>
            </div>
            <footer>
                <a
                    href='http://www.view-privacy-policy.co.uk/Privacy-Policy'
                    target='_blank'
                    rel='noopener noreferrer'>
                    {t('privacy_policy')}
                </a>
            </footer>
        </div>
    );
};

export default LayoutContent;
